export const ROLE = {
  SystemAdministrator: "SystemAdministrator",
  Employee: "Employee",
  Accountant: "Accountant",
  Manager: "Manager",
  AdministrativeAffairs: "İdari İşler",
  AdministrativeAffairsManager: "İdari İşler Yöneticisi",
};
